"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var BrandAreaRoot_1 = require("./controls/BrandAreaRoot");
var BrandAreaDir_1 = require("./controls/BrandAreaDir");
var BrandAreaImg_1 = require("./controls/BrandAreaImg");
var BrandObjTreeList_1 = require("./controls/BrandObjTreeList");
var BrandImageContentList = /** @class */ (function (_super) {
    __extends(BrandImageContentList, _super);
    function BrandImageContentList(props) {
        return _super.call(this, props) || this;
    }
    BrandImageContentList.prototype.componentWillMount = function () {
        var _this = this;
        this.setState({
            areaRenderMode: "none"
        }, function () {
            _this.props.ctxData.LoadData();
        });
    };
    BrandImageContentList.prototype.onRootNodeSelect = function (key) {
        this.setState({
            areaRenderMode: "root",
            brandKey: key,
            dirKey: ""
        });
    };
    BrandImageContentList.prototype.onDirNodeSelect = function (bKey, dKey) {
        this.setState({
            areaRenderMode: "dir",
            brandKey: bKey,
            dirKey: dKey
        });
    };
    BrandImageContentList.prototype.onDirItemSelect = function (bKey, dKey) {
        this.setState({
            areaRenderMode: "dir",
            brandKey: bKey,
            dirKey: dKey
        });
    };
    BrandImageContentList.prototype.goBackToDirListClick = function (brandId) {
        this.setState({
            areaRenderMode: "root",
            brandKey: brandId,
            dirKey: ""
        });
    };
    BrandImageContentList.prototype.selectImageClick = function (brandId, dirName, fileName) {
        if (this.props.onSelectImage) {
            this.props.onSelectImage(this.props.ctxData.getBrandItemById(brandId).identity, dirName, fileName);
        }
    };
    BrandImageContentList.prototype.getRenderArea = function () {
        if (this.state.areaRenderMode === "none") {
            return (React.createElement(BrandAreaRoot_1.default, null));
        }
        if (this.state.areaRenderMode === "root") {
            return (React.createElement(BrandAreaDir_1.default, { data: this.props.ctxData, brandId: this.state.brandKey, onSelectDirectory: this.onDirItemSelect.bind(this) }));
        }
        if (this.state.areaRenderMode === "dir") {
            return (React.createElement(BrandAreaImg_1.default, { data: this.props.ctxData, brandId: this.state.brandKey, dirName: this.state.dirKey, onGoBackClick: this.goBackToDirListClick.bind(this), onSelectImage: this.selectImageClick.bind(this) }));
        }
        return null;
    };
    BrandImageContentList.prototype.render = function () {
        return (React.createElement("div", { style: { height: "500px", width: "750px" } },
            React.createElement("div", { style: {
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "nowrap",
                    justifyContent: "flex-start",
                    height: "100%"
                } },
                React.createElement(BrandObjTreeList_1.default, { data: this.props.ctxData, onSelectRootNode: this.onRootNodeSelect.bind(this), onSelectDirNode: this.onDirNodeSelect.bind(this), selectedBrandId: this.state.brandKey, selectedDirName: this.state.dirKey, forceSelectDirMode: this.state.areaRenderMode }),
                this.getRenderArea())));
    };
    return BrandImageContentList;
}(React.Component));
exports.default = BrandImageContentList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/dialogs/ui/dlgSelectBrandImage/BrandImageContentList.tsx
// module id = 2390
// module chunks = 0